module.exports = __webpack_public_path__ + "static/media/TechSpecs.a15765f0.png";